import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBDataTable } from "mdbreact";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Select, Modal, Switch } from "antd";

import Loading from "../Loading";
import { getStoreType } from "../../../../dynamicController";

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const PromotionCard = ({ id, role, token }) => {
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [modal, setModal] = useState(false)
    const [type, setType] = useState("RELOAD")
    const [show, setShow] = useState(true)
    const [image, setImage] = useState("")
    const [imageUrl, setImageUrl] = useState("")
    const [selectedId, setSelectedId] = useState("")
    const [typeOption, setTypeOption] = useState([])
    const [allTypeOption, setAllTypeOption] = useState([
        {
            value: "RELOAD",
            label: t("Reload")
        },
        {
            value: "DNG",
            label: t("Drop n Go Service")
        },
        {
            value: "LAUNDRY PASS",
            label: t("Laundry Pass")
        },
    ])

    useEffect(() => {
        if (id && role) {
            setLoading(true)
            axios
                .post("/api/admin/setting/fetchPromotion", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.data)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }, [id, role])

    useEffect(() => {
        let option = []
        for (let i = 0; i < allTypeOption.length; i++) {
            let foundData = data.filter(data => data.type === allTypeOption[i].value)[0]
            if (!foundData) {
                option.push(allTypeOption[i])
            }
        }

        setTypeOption(option)
    }, [data, allTypeOption])

    const editPromotionModal = (id) => {
        const selectedData = data.filter(data => data.id === id)[0]
        if (selectedData) {
            setImageUrl(selectedData.image)
            setType(selectedData.type)
            setShow(selectedData.show)
            setSelectedId(selectedData.id)
            setModal(true)
        }
    }

    const createPromotionModal = () => {
        setType(typeOption[0].value)
        setShow(true)
        setImage("")
        setImageUrl("")
        setSelectedId("")
        setModal(true)
    }

    const handleImage = (e) => {
        const file = e.target.files[0];

        const imageRegex = /image\//g;
        const jpgRegex = /.jpg/g;
        const pngRegex = /.png/g;
        const jpegRegex = /.jpeg/g;

        if (file) {
            if (imageRegex.test(file.type)) {
                if (jpgRegex.test(file.name) || pngRegex.test(file.name) || jpegRegex.test(file.name)) {
                    if (file.size > 2097152) {
                        mySwal.fire(t("Info"), t("The image size is over 2MB"), "info");
                        e.target.value = "";
                    } else {
                        setImage(file)
                        setImageUrl(URL.createObjectURL(file))
                    }
                } else {
                    mySwal.fire(t("Info"), t("Please only use png, jpg or jpeg file extension type"), "info");
                    e.target.value = "";
                }
            } else {
                mySwal.fire(t("Info"), t("Please only use image type file"), "info");
                e.target.value = "";
            }
        } else {
            setImage("")
            setImageUrl("")
        }
    }

    const submit = (e) => {
        e.preventDefault();

        if (!type) {
            mySwal.fire(t("Missing Field"), t("Please select the type"), "info");
        } else {
            setLoading(true)

            let formData = new FormData()
            formData.append("type", type)
            formData.append("show", show)
            formData.append("id", id)
            formData.append("role", role)

            if (image) {
                formData.append("image", image)
            }

            axios.post("/api/admin/setting/promotion", formData, { headers: { "auth-token": token } })
                .then(res => {

                    axios.post("/api/admin/setting/fetchPromotion", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setData(res.data.data)
                            setLoading(false)
                            setModal(false)
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                })
        }
    }

    let tableData = {
        columns: [
            {
                label: t("Type"),
                field: "type",
                sort: "asc"
            },
            {
                label: t("Display in Promotion Page"),
                field: "show",
                sort: "asc"
            },
            {
                label: t("Action"),
                field: "action",
                sort: "asc"
            },
        ],
        rows: []
    }

    if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const dataObject = {
                type: t(data[i].type),
                show: data[i].show ? t("Yes") : t("No"),
                action: (
                    <div>
                        <i className="bi bi-pencil-square" onClick={() => editPromotionModal(data[i].id)}></i>
                    </div>
                )
            }
            tableData.rows.push(dataObject)
        }
    }

    return (
        <div>
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h5 className="card-title">{t("Promotion")}</h5>

                    {
                        typeOption.length > 0 ? (
                            <button className="btn btn-primary" type="button" onClick={() => createPromotionModal()}>
                                {t("Add Promotion")}
                            </button>
                        ) : null
                    }
                </div>

                <div className="card-body">
                    {
                        loading ? <Loading /> : (
                            <div>
                                <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                            </div>
                        )
                    }
                </div>
            </div>

            <Modal
                title={t("Promotion")}
                open={modal}
                footer={null}
                onCancel={() => setModal(!modal)}
            >
                <form onSubmit={submit}>
                    <div className="form-group text-left">
                        <label htmlFor="type">{t("Type")}</label>
                        <Select
                            className="select-input"
                            style={{ width: "100%" }}
                            placeholder={t("Select type")}
                            options={selectedId ? allTypeOption : typeOption}
                            showSearch
                            optionFilterProp="label"
                            onChange={(value) => setType(value)}
                            value={type}
                            disabled={selectedId ? true : false}
                        />
                    </div>

                    <div className="form-group text-left">
                        <label htmlFor="show">{t("Display in Promotion Page")}</label><br />
                        <Switch value={show} onChange={() => setShow(!show)} />
                    </div>

                    {
                        imageUrl ? (
                            <div style={{ maxWidth: "50%", display: "block", margin: "auto", textAlign: "center" }}>
                                <img src={imageUrl} alt="" className="img-fluid" />
                            </div>
                        ) : null
                    }

                    <div className="form-group text-left">
                        <label htmlFor="image">{t("Image")}</label>
                        <input type="file" accept="image/*" id="logo" name="logo" className="form-control m-0 p-0" onChange={(e) => handleImage(e)} />
                    </div>

                    <div className="text-center pt-3">
                        {
                            loading
                                ? (
                                    <div className="text-center">
                                        <div className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`} role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                )
                                : <input type="submit" value={t("Submit")} className="btn btn-primary mx-2" />
                        }
                        <button type="button" className="btn btn-secondary" onClick={e => setModal(!modal)}>
                            {t("Close")}
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    )
}

export default PromotionCard;